import { graphql } from "../gql";

export const assignClaimsToAuditGroupMutationDoc = graphql(`
  mutation assignClaimsToAuditGroup($input: AssignClaimsToAuditGroupInput!) {
    assignClaimsToAuditGroup(input: $input) {
      claimAuditGroup {
        appealDueDate
        auditStartDate
        createdAt
        disputeDueDate
        finalProviderReportSentDate
        id
        name
        qaDueDate
        totalClaimsCount
      }
    }
  }
`);
